// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"dd8971fe","57":"0f62c9bf","124":"def11c7a","449":"2b65a822","453":"d159897f","465":"681c92c9","660":"8a222075","697":"e4c4a9f1","712":"6718b1b8"}[chunkId] + ".chunk.js";
};